import moment from 'moment';

export function useLicencaTipo(tipo, licArray) {
  const userLics = Array.isArray(licArray) ? licArray : [];
  const hoje = moment().startOf('day');

  const temLicenca = userLics.some(lic => {
    return lic.tipo === tipo &&
      lic.ativo === 1 &&
      moment(lic.dataval).startOf('day').isSameOrAfter(hoje);
  });

  return temLicenca;
}

export function useLicencaModulo(modulo, licArray) {
  const userLics = Array.isArray(licArray) ? licArray : [];
  const hoje = moment().startOf('day');

  // encontra a licença cujo campo “modulo” bate com o parâmetro
  const licenca = userLics.find(l => l.modulo === modulo);
  if (!licenca) {
    return {ativo: false, dataval: 'indefinido'};
  }

  let bativo = licenca.ativo === 1 && moment(licenca.dataval).startOf('day').isSameOrAfter(hoje);
  return {ativo: bativo, dataval: licenca.dataval};
}

export function getConfigValor(configs, chave) {
  if (!Array.isArray(configs) || !chave) return null;
  const item = configs.find(c => c?.chave === chave);
  return item?.valor ?? null;
}